import { render } from "./AdminLinksTableComponent.vue?vue&type=template&id=7ec6c6aa"
import script from "./AdminLinksTableComponent.vue?vue&type=script&lang=js"
export * from "./AdminLinksTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__